import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n/LanguageProvider";
import { toTaxonomyPath } from "../../utils/slug";
import "./TaxonomyChips.sass";

/**
 * List of links to category ("domeniu") or place ("țară") pages with the number of profiles in each.
 */
function TaxonomyChips({ type, items, limit = 0 }) {
    const { localizedPath } = useTranslation();
    const visibleItems = limit > 0 ? (items || []).slice(0, limit) : items || [];

    if (visibleItems.length === 0) {
        return null;
    }

    return (
        <ul className="directory__chips">
            {visibleItems.map((item) => (
                <li key={item.id}>
                    <Link
                        className="directory__chip"
                        to={localizedPath(toTaxonomyPath(type, item))}
                        style={item.color ? { borderColor: item.color } : undefined}>
                        <span className="directory__chip-name">{item.name}</span>
                        <span className="directory__chip-count">{item.total}</span>
                    </Link>
                </li>
            ))}
        </ul>
    );
}

export default TaxonomyChips;
